import { GitFork } from 'lucide-react'
import { MindMapCanvas } from '../components/mindmap/MindMapCanvas'

export function MindMapPage() {
  return (
    <div className="flex flex-col" style={{ height: 'calc(100vh - 10rem)' }}>
      <div className="flex items-center justify-between flex-shrink-0 mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-purple-400 to-purple-600 rounded-xl flex items-center justify-center shadow-lg shadow-purple-500/30">
            <GitFork className="w-5 h-5 text-white" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-gray-900 dark:text-white">Doctrine Mind Map</h1>
            <p className="text-xs text-gray-500 dark:text-gray-400">Concepts, relationships, and cross-references</p>
          </div>
        </div>
      </div>
      <div className="flex-1 min-h-0 rounded-xl overflow-hidden border border-gray-200 dark:border-gray-700 bg-white dark:bg-surface-900">
        <MindMapCanvas />
      </div>
    </div>
  )
}
